import { render, staticRenderFns } from "./veStuMoralResourceMy.vue?vue&type=template&id=26060266&scoped=true"
import script from "./veStuMoralResourceMy.vue?vue&type=script&lang=js"
export * from "./veStuMoralResourceMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26060266",
  null
  
)

export default component.exports